// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"6183588e","375":"1cc0876b"}[chunkId] + ".chunk.css";
};